"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const starthreequarter = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-starthreequarter` : '') + (description ? ` desc-starthreequarter` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-starthreequarter"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-starthreequarter"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M4.602 23.068a.813.813 0 0 1-.273-.84l.872-3.172 1.087-3.966-5.3-5.253a.805.805 0 0 1 .385-1.356l.115-.018 6.44-.638L11.271 1.2a.819.819 0 0 1 .3-.325c.095-.06.203-.1.317-.117l.115-.008.11.012a.819.819 0 0 1 .616.438l3.346 6.629 6.44.638a.805.805 0 0 1 .5 1.374l-5.3 5.253 1.965 7.138a.813.813 0 0 1-1.151.935l-6.528-3.232-6.518 3.228a.816.816 0 0 1-.881-.095Zm10.401-3.326 2.821 1.402-1.555-5.652a1.5 1.5 0 0 1 .291-1.355l.1-.108 4.25-4.214-4.983-.493c-.238-.024-.547-.173-.928-.448l.004 10.868Z",
    fill: "inherit"
  }));
};
var _default = exports.default = starthreequarter;